<div class="grid center-item guts-m-t-3">
  <div class="grid__col-8 center-item">
    <div class="task-alert center-text" [ngClass]="{ isMobile: isMobile }">
      <!--Header-->
      <h1 *ngIf="header" class="h1" [textContent]="header"></h1>

      <!--Description-->
      <div
        *ngIf="description"
        class="par guts-p-t-1"
        [innerHTML]="description"
      ></div>

      <!--Action-->
      <a
        *ngIf="showAction"
        [href]="url"
        [attr.role]="role"
        (click)="handleAction($event)"
        class="btn btn-primary guts-m-t-3"
        data-dgat="taskAlert-95f"
      >
        <span [textContent]="actionLabel"></span>
      </a>
    </div>
  </div>
</div>
